import { render, staticRenderFns } from "./RetailCouponList.vue?vue&type=template&id=e8c2c228&scoped=true&"
import script from "./RetailCouponList.vue?vue&type=script&lang=js&"
export * from "./RetailCouponList.vue?vue&type=script&lang=js&"
import style0 from "./RetailCouponList.vue?vue&type=style&index=0&id=e8c2c228&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c2c228",
  null
  
)

export default component.exports